import React from "react";

import ModuleFormModal, {
  type ModuleFormSubmitInput,
} from "../../../../../components/content/ModuleFormModal/ModuleFormModal";

type ModernizerAddModuleInput = {
  title: string;
  description?: string;
};

interface ModernizerAddModuleModalProps {
  open: boolean;
  isSubmitting: boolean;
  onClose: () => void;
  onSave: (input: ModernizerAddModuleInput) => Promise<void>;
}

function ModernizerAddModuleModal({ open, isSubmitting, onClose, onSave }: ModernizerAddModuleModalProps) {
  const handleSubmit = ({ title, description }: ModuleFormSubmitInput) => onSave({ title, description });

  return (
    <ModuleFormModal
      visible={open}
      title="Add Module"
      isSubmitting={isSubmitting}
      onClose={onClose}
      onSubmit={handleSubmit}
      style={{ maxWidth: 500 }}
    />
  );
}

export default ModernizerAddModuleModal;
export type { ModernizerAddModuleInput };
